import mapboxgl from 'mapbox-gl'; // or "const mapboxgl = require('mapbox-gl');"
import {bboxPolygon, bbox, point, featureCollection, truncate} from '@turf/turf';

mapboxgl.accessToken = 'pk.eyJ1IjoicG1hc3QiLCJhIjoiY2lvMTNldTY5MDB2Y3dkbHkzbTNyZzlpZCJ9.yAZnXPZIUtQV7Iwmc4eHhA';
const map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/pmast/cksrvti8a0cml17rryos8hszw',
    center: [10, 54.5],
    zoom: 3,
    renderWorldCopies: false,
    maxBounds: [[-180, -85], [180, 85]],
});

map.on('load', () => {
    initMap();
});

const truncateOptions = {precision: 4, coordinates: 2};
let points = [];
let markers = [];

function initMap() {
    map.addSource('personalBB', {
        type: 'geojson',
        data: {
            'type': 'FeatureCollection',
            'features': []
        }
    });

    map.addLayer({
        'id': 'BBbox',
        'type': 'line',
        'source': 'personalBB',
        'paint': {
            'line-color': 'red',
            'line-opacity': 1,
            'line-width': 1
        }
    });

    points = getPointsFromUrl() || [];

    if (points && points.length > 0) {
        points.forEach(item => {
            markers.push(new mapboxgl.Marker().setLngLat(item.geometry.coordinates).addTo(map));
        });
        const bbSource = map.getSource('personalBB');
        const bbBox = getBBboxPolygon(points)
        bbSource.setData(bbBox);
        map.fitBounds(bbox(bbBox), {padding: 50});
    }
    

    map.on('click', ({ lngLat }) => addPoiont(lngLat));
}

function addPoiont(lngLat) {
    const bbSource = map.getSource('personalBB');
    const gjPoint = point([lngLat.lng, lngLat.lat]);
    const truncatedGjPoint = truncate(gjPoint, truncateOptions)
    points.push(truncatedGjPoint);
    savePointsToURL(points);

    const marker = new mapboxgl.Marker().setLngLat(lngLat).addTo(map);
    markers.push(marker);

    const boundingBox = getBBboxPolygon(points);
    bbSource.setData(boundingBox);
}

function savePointsToURL(points) {
    const queryString = points
        .map(point => point.geometry.coordinates.join('x'))
        .join('~');
    window.history.pushState(null, null, `?points=${queryString}`);
    console.log(123);
}

function getPointsFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const pointsStrings = params?.get('points')?.split('~');
    if (!pointsStrings) return;
    return pointsStrings.map(item => point(item.split('x').map(value => Number(value))));
}

function getBBboxPolygon(points) {
    const pointCollection = featureCollection(points);
    const geoJsonBBbox = bbox(pointCollection);
    return bboxPolygon(geoJsonBBbox);
}

document.getElementById('clearButton').addEventListener('click', () => {
    const bbSource = map.getSource('personalBB');
    points = [];
    bbSource.setData(getBBboxPolygon(points));
    markers.forEach(marker => marker.remove());
    markers = [];
    const url = new URL(window.location.href);
    window.history.pushState(null, null, url.pathname);
});